// The server publishes the dashboard payload only to connections that ask for it, so the pages that show
// it (the Dashboard and the Print Queue) subscribe while they're open. Counted, because two of them can be
// mounted at once during a route change. The transport is registered by dashboardSetup once the hub or the
// shared worker exists, which can be after the first page has mounted.

export type DashboardSubscriptionTransport = (subscribed: boolean) => void;

let subscriptionCount = 0;
let transport: DashboardSubscriptionTransport | null = null;

export function subscribeDashboard(): void {
    subscriptionCount++;
    if (subscriptionCount === 1) transport?.(true);
}

export function unsubscribeDashboard(): void {
    if (subscriptionCount === 0) return;
    subscriptionCount--;
    if (subscriptionCount === 0) transport?.(false);
}

export function isDashboardSubscribed(): boolean {
    return subscriptionCount > 0;
}

/** Registers how this tab tells the server, and passes on a subscription made before it existed. */
export function setDashboardSubscriptionTransport(next: DashboardSubscriptionTransport): void {
    transport = next;
    if (subscriptionCount > 0) transport(true);
}
